import Module from './Module';
import axios from 'axios';
import qs from 'qs';


class PlaceModule extends Module {
  constructor() {
    super('places', '/api/v1/places', true);
    this.actionTypes.GET_CLAIM_BUSINESS_REQUEST = 'GET_CLAIM_BUSINESS_REQUEST';
  }

  getClaimBusinessRequest = params => dispatch => dispatch({
    type: this.actionTypes.GET_CLAIM_BUSINESS_REQUEST,
    payload: axios.get(`${this.api}/claim-business/request`, {
      params,
      // eslint-disable-next-line no-shadow
      paramsSerializer: params => qs.stringify(params),
    }),
  });

  getClaimBusinessRequestById = id => dispatch => dispatch({
    type: this.actionTypes.GET_CLAIM_BUSINESS_REQUEST,
    payload: axios.get(`${this.api}/claim-business/request/${id}`),
  });

  updateClaimBusinessRequest = (id, data) => dispatch => dispatch({
    type: this.actionTypes.GET_CLAIM_BUSINESS_REQUEST,
    payload: async () => {
      await axios.put(`${this.api}/claim-business/request/${id}`, data);
      return axios.get(`${this.api}/claim-business/request/${id}`);
    },
  });

  reducer(state = this.initialState, action) {
    const { GET_CLAIM_BUSINESS_REQUEST } = this.actionTypes;
    const { payload } = action;
    const data = payload && payload.data ? payload.data.data : null;

    switch (action.type) {
      case `${GET_CLAIM_BUSINESS_REQUEST}_FULFILLED`:
        return { ...state, isLoading: false, claimBusinessRequests: data, error: null };

      default:
        return super.reducer(state, action);
    }
  }
}

const module = new PlaceModule();

export const {
  get, getById, save, remove, resetState, resetSuccessSave,
  getClaimBusinessRequest, getClaimBusinessRequestById, updateClaimBusinessRequest,
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/places.js